import { css } from '@/styled-system/css';

export const filterChipLabelStyles = css.raw({
  color: 'text.neutral',
  hyphens: 'auto',
  textStyle: 'body-sm-bold',
});
